import { createContext, ReactNode, useCallback, useState } from 'react';
import { AppObject } from '../widgets/AppCard';
import { MenuGroup } from '../widgets/LeftMenu/LeftMenuGroup';

interface AppsMenuContextType {
  groups: MenuGroup[];
  handleApps: (apps: AppObject[]) => void;
}

interface AppsMenuContextProviderProps {
  children: ReactNode;
}

export const AppsMenuContext = createContext({} as AppsMenuContextType);

export function AppsMenuContextProvider({
  children,
}: AppsMenuContextProviderProps) {
  const [groups, setGroups] = useState<MenuGroup[]>([]);

  const handleApps = useCallback((apps: AppObject[]) => {
    let scopedGroups: MenuGroup[] = [];

    if (apps)
      apps.forEach((app) => {
        const groupApp = {
          title: app.name,
          iconName: app.iconName,
          key: app.key,
        };

        if(app.hasui){
        const groupExists = scopedGroups.find(
          (group) => group.title === app.group
        );

        if (groupExists) {
          const newGroups = scopedGroups.map((group) => {
            if (group.title === app.group) {
              group.items.push(groupApp);
            }
            return group;
          });
          scopedGroups = newGroups;
        } else {
          const newGroup = {
            title: app.group,
            items: [groupApp],
          };
          scopedGroups.push(newGroup);
        }}
      });

    setGroups(scopedGroups);
  }, []);

  return (
    <AppsMenuContext.Provider value={{ groups, handleApps }}>
      {children}
    </AppsMenuContext.Provider>
  );
}
